import React, { memo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from 'moment';
import "react-day-picker/lib/style.css";
import "moment/locale/ja";

import { PopoverText } from '../../common/parts/PopoverText';

import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';

export const FormrRequestDate = memo((props) => {
  const isConfirm = useRecoilValue(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);

  // 日付をYYYY-MM-DDの書式で返すメソッド
  const formatDate = (dt) => {
    const formatRules = [
      "YYYY-MM-DD", "YYYY/MM/DD", "YYYYMMDD",
    ]
    let formatedDate = moment(dt, formatRules).format('YYYY-MM-DD');
    return formatedDate;
  }

  const onChangeFirstDt = (selectedDay, modifiers, dayPickerInput) => {
    const input = dayPickerInput.getInput();
    setOrderData({...orderData, requestdt1: formatDate(input.value)});
  }
  const onChangeSecondDt = (selectedDay, modifiers, dayPickerInput) => {
    const input = dayPickerInput.getInput();
    setOrderData({...orderData, requestdt2: formatDate(input.value)});
  }
  const onChangeThirdDt = (selectedDay, modifiers, dayPickerInput) => {
    const input = dayPickerInput.getInput();
    setOrderData({...orderData, requestdt3: formatDate(input.value)});
  }
  const onChangeFirstTm = (e) => {
    setOrderData({...orderData, requestdt1_ampm: e.target.value});
  }
  const onChangeSecondTm = (e) => {
    setOrderData({...orderData, requestdt2_ampm: e.target.value});
  }
  const onChangeThirdTm = (e) => {
    setOrderData({...orderData, requestdt3_ampm: e.target.value});
  }

  return (
    <>
      <p className="h3">受診希望日 
        <PopoverText textTitle="受診希望日" textBody="ご希望の受診希望日が〜〜〜、調整のご連絡を差し上げます。" />
      </p>
      <p className="text-danger">
        第一から第三希望日を選択してください。<br />
        無断キャンセルや度重なる日程変更は、医療機関へご迷惑となりますのでお控えください。<br />
        健診のお受入れが難しくなってしまう場合もございますので、ご注意ください。
      </p>

      <div className="card mb-4">
        <div className="card-body">
        <div className="input-group mb-3">
            <label className="input-group-text">第一</label>
            <DayPickerInput
              inputProps={{ 
                className: 'form-control',
                readOnly: !isConfirm,
                disabled: isConfirm,
              }}
              dayPickerProps={{
                localeUtils: MomentLocaleUtils,
                locale: "ja",
                disabledDays: [
                  {
                    before: new Date(),
                  },
                ]
              }}
              placeholder='日付を選択(必須)'
              onDayChange={onChangeFirstDt}
              value={orderData.requestdt1}
            />
            <select name="" id="firstTime" className="form-control" onChange={onChangeFirstTm} disabled={isConfirm} value={orderData.requestdt1_ampm}>
              <option value="0">終日</option>
              <option value="1">午前</option>
              <option value="2">午後</option>
            </select>
          </div>
          <div className="input-group mb-3">
            <label className="input-group-text">第二</label>
            <DayPickerInput
              inputProps={{ 
                className: 'form-control',
                readOnly: !isConfirm,
                disabled: isConfirm,
              }}
              dayPickerProps={{
                localeUtils: MomentLocaleUtils,
                locale: "ja",
                disabledDays: [
                  {
                    before: new Date(),
                  },
                ]
              }}
              placeholder='日付を選択(必須)'
              onDayChange={onChangeSecondDt}
              value={orderData.requestdt2}
            />
            <select name="" id="secondTime" className="form-control" onChange={onChangeSecondTm} disabled={isConfirm} value={orderData.requestdt2_ampm}>
              <option value="0">終日</option>
              <option value="1">午前</option>
              <option value="2">午後</option>
            </select>
          </div>
          <div className="input-group">
            <label className="input-group-text">第三</label>
            <DayPickerInput
              inputProps={{ 
                className: 'form-control',
                readOnly: !isConfirm,
                disabled: isConfirm,
              }}
              dayPickerProps={{
                localeUtils: MomentLocaleUtils,
                locale: "ja",
                disabledDays: [
                  {
                    before: new Date(),
                  },
                ]
              }}
              placeholder='日付を選択(必須)'
              onDayChange={onChangeThirdDt}
              value={orderData.requestdt3}
            />
            <select name="" id="thirdTime" className="form-control" onChange={onChangeThirdTm} disabled={isConfirm} value={orderData.requestdt3_ampm}>
              <option value="0">終日</option>
              <option value="1">午前</option>
              <option value="2">午後</option>
            </select>
          </div>
        </div>
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});